import { render } from "./ReportesFiltros_sap_cliente.vue?vue&type=template&id=3111692f&bindings={\"breadcrumbA\":\"data\",\"breadcrumbB\":\"data\",\"descripcion\":\"data\",\"triggers\":\"data\",\"personal\":\"data\",\"obtenerPersonal\":\"options\",\"refrescarPersonal\":\"options\"}"
import script from "./ReportesFiltros_sap_cliente.vue?vue&type=script&lang=js"
export * from "./ReportesFiltros_sap_cliente.vue?vue&type=script&lang=js"

import "./ReportesFiltros_sap_cliente.vue?vue&type=style&index=0&lang=scss"
script.render = render

export default script